import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import { lightboxStyles } from './css/new-styles';

export const Lightbox = injectSheet(lightboxStyles)(({
  buttonOkText,
  isOpen,
  children,
  classes,
  title,
  onCancel,
  onSubmit,
  i18n,
}) => (
  <ReactModal
    isOpen={isOpen}
    overlayClassName={classes.overlay}
    className={classes.container}
    onRequestClose={onCancel}
  >
    <div className={classNames('lightbox', classes.lightbox)}>
      <button
        className="lightbox-button-close close"
        onClick={onCancel}
        aria-label={i18n.getString('Button_Close')}
      >
        <span className="closeimage" />
      </button>
      <div className="lightbox-header" >
        <h3 className={classNames('lightbox-title', classes.title)}>
          {title}
        </h3>
      </div>
      <div className={classNames('lightbox-body', classes.body)}>
        {children}
      </div>
      <div className={classNames('lightbox-footer', classes.footer)}>
        <button className={classNames('lightbox-button-ok', 'btn', 'btn-primary', classes.buttonOk)} onClick={onSubmit}>{buttonOkText}</button>
      </div>
    </div>
  </ReactModal>
));

Lightbox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  buttonOkText: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

Lightbox.displayName = 'Lightbox';
